import { useSearch } from '@tanstack/react-router';
import type { ReactNode } from 'react';

import { AiCioFileDock, useAiCioConversationExists } from '@modules/ai-cio';

export function useVaultFileChatDock(): ((open: boolean) => ReactNode) | undefined {
  const { c } = useSearch({ from: '/fullscreen/vault/$fileId' });
  const chatId = useAiCioConversationExists(c) ? c : undefined;
  if (!chatId) return undefined;
  return (open: boolean) => <AiCioFileDock conversationId={chatId} open={open} />;
}
